"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var VStep_1 = require("../../VStep");
var VSteps_1 = require("../../VSteps");
var style_1 = require("./style");
var SubmitButton = function () {
    var mainCtx = (0, react_1.useContext)(VSteps_1.MainStepsContext);
    var ctx = (0, react_1.useContext)(VStep_1.StepContext);
    return (react_1.default.createElement(react_1.default.Fragment, null, ctx.displaySubmit && (react_1.default.createElement(style_1.SButton, { style: { backgroundColor: mainCtx.mainColor }, intent: 'primary', onClick: function () {
            ctx.goToNextStep();
        } }, "Done"))));
};
exports.default = SubmitButton;
